import debounce from "lodash.debounce";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from "body-scroll-lock";

const mobileMixin = {
  data() {
    return {
      onResize: null,
      mounted: false
    };
  },
  created() {
    this.onResize = debounce(() => this.detectMobile(), 500);
  },
  mounted() {
    this.mounted = true;
    this.detectMobile();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    if (this.mobile) clearAllBodyScrollLocks();
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    openMobile() {
      disableBodyScroll(this.multiselect().list);
      this.adjustMobileListHeight();
    },
    closeMobile() {
      enableBodyScroll(this.multiselect().list);
      this.resetMobileListHeight();
    },
    detectMobile() {
      this.mobile =
        typeof window !== "undefined" &&
        !window.matchMedia("(min-width: 768px)").matches;
      this.fullscreen = this.desktopFullscreen || this.mobile;
    },
    adjustMobileListHeight() {
      if (!this.mobile || this.mobileListHeightAdjusted) return;

      //Input field height
      const inputHeight = 61;

      // Default list height for non iOS devices
      let height = `calc(100% - ${inputHeight}px)`;

      // iOS does not account for virtuel keyboard
      // in viewport height, hence:
      if (this.iOS()) {
        // iOS version > 13
        const visualViewport = this.visualViewport();
        if (visualViewport) {
          height = `${visualViewport.height - inputHeight}px`;
          if (
            window.getComputedStyle(this.multiselect().list).display === "block"
          ) {
            // Get the <ul> element
            const unorderedList = this.multiselect().list.querySelector(
              ":scope > ul"
            );
            // Create a new MutationObserver instance
            const observer = new MutationObserver((mutationsList, observer) => {
              // Look through all mutations that just occurred
              for (let mutation of mutationsList) {
                // If the addedNodes property has one or more nodes
                if (mutation.addedNodes.length) {
                  const listItems = unorderedList.querySelectorAll("li");
                  if (listItems.length > 12) {
                    this.multiselect().list.scrollTop = 0;
                    observer.disconnect();
                    console.info("Observe, scrollTop, disconnect observer");
                  }
                }
              }
            });
            // Start observing the <ul> element for changes
            observer.observe(unorderedList, { childList: true });
          }
        } else {
          // Conservatively assume 40% of vh available
          height = `calc(-${inputHeight}px + 40%)`;
        }
      }

      this.multiselect().list.style.height = height;
    },
    resetMobileListHeight() {
      this.multiselect().list.style.height = "auto";
      this.mobileListHeightAdjusted = false;
    },
    iOS() {
      return navigator.userAgent.match(/iphone|ipod|ipad/i);
    },
    visualViewport() {
      return typeof window !== "undefined" && window.visualViewport;
    }
  }
};

export default mobileMixin;
